var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "物流探查预警",
        visible: _vm.isShow,
        width: "710px",
        center: "",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c("div", [
        _vm.loading
          ? _c("div", { staticClass: "logistic-dialog-waiting" }, [
              _c("div", { staticClass: "logistic-dialog" }, [
                _c("img", {
                  staticClass: "sysnc-img",
                  attrs: { src: require("@/assets/images/wait.gif") },
                }),
              ]),
              _c("div", { staticClass: "logistic-dialog" }, [
                _vm._v("小管家正在努力搬运中，请稍等"),
              ]),
            ])
          : _c(
              "div",
              [
                _c(
                  "div",
                  { staticStyle: { "margin-bottom": "20px" } },
                  [
                    _c(
                      "el-alert",
                      {
                        attrs: {
                          "show-icon": "",
                          closable: false,
                          effect: "light",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "根据订单地址和物流公司，判断快递履约过程中经过的中转分拨和末端派件网点是否存在异常，结果仅供参考。"
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.tbody,
                      "empty-text": "系统经计算，当前所选订单均可正常送达。",
                      "max-height": "400",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        property: "orderId",
                        label: "订单编号",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        property: "undeliverableReason",
                        label: "不可达原因",
                        width: "240",
                      },
                    }),
                    _c(
                      "el-table-column",
                      { attrs: { property: "recommendedExpress" } },
                      [
                        _c(
                          "template",
                          { slot: "header" },
                          [
                            _c("span", [_vm._v("推荐物流")]),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "light",
                                  content:
                                    "根据订单所在线路物流公司的揽签时长进行推荐",
                                  placement: "right-end",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-info y-fc-4C84FF y-ml-10 y-c-p",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c("el-pagination", {
                  staticClass: "y-t-ac y-mt-20",
                  attrs: {
                    "current-page": _vm.pageNo,
                    "page-sizes": [100, 200, 300, 400],
                    "page-size": _vm.limit,
                    layout: "total, sizes, prev, pager, next",
                    total: _vm.total,
                  },
                  on: {
                    "size-change": _vm.limitChange,
                    "current-change": _vm.pageChange,
                    "update:currentPage": function ($event) {
                      _vm.pageNo = $event
                    },
                    "update:current-page": function ($event) {
                      _vm.pageNo = $event
                    },
                  },
                }),
              ],
              1
            ),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.tbody.length
            ? _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("关 闭"),
              ])
            : !_vm.loading
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.closeDialog } },
                [_vm._v("关 闭")]
              )
            : _vm._e(),
          !_vm.loading && _vm.tbody.length
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.copyOrderIdsFn },
                },
                [_vm._v("复制订单号")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }